import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-sand px-5 py-16 sm:py-20" data-id="element-102" data-mp="1o3x3nprb6w3l">
      <div className="mx-auto max-w-xl text-center" data-id="element-103" data-mp="1o3do2fp4sjsq">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-white text-brand" data-id="element-104" data-mp="223oddeaslqbs">
          <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-105" data-mp="1x5d5va7yzrwq" />
        </span>
        <h2 className="mt-6 font-display text-xl font-black uppercase tracking-wide text-ink sm:text-2xl" data-id="element-106" data-mp="19e7pmty4axlw">
          Garanzia &ldquo;Soddisfatti o Rimborsati&rdquo;
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-ink/60" data-id="element-107" data-mp="1j4k7ufigmeov">
          Prova il materiale per 7 giorni. Se non è quello che ti aspettavi o
          non ti fa risparmiare ore di lavoro e stress, ti rimborseremo ogni
          centesimo. Nessuna domanda: inviaci un&apos;email e il rimborso è
          fatto.
        </p>
        <a href="#faq" className="mt-5 inline-block text-xs font-bold text-brand underline underline-offset-4 transition-colors duration-150 ease-out hover:text-brand-dark" data-id="element-108" data-mp="lo4x6cqajpmr">
          Politica di rimborso completa
        </a>
      </div>
    </section>;
}